import React from "react";

const MessengerChatBox = () => {
  const redirectToMessenger = () => {
    window.location.href = "https://m.me/chatnshops.official";
  };

  return (
    <div
      className=" fixed bottom-4 right-4 p-2  text-white rounded-full cursor-pointer z-40"
      onClick={redirectToMessenger}
    >
      <img
        src={process.env.PUBLIC_URL + "/icons/popup/messenger.png"}
        alt="messenger"
        className="w-12 h-12"
      />
    </div>
  );
};

export default MessengerChatBox;
